import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { List, PictureAsPdf } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Button,
    ButtonGroup,
    CircularProgress,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import LoadingPopUp from 'app/components/LoadingPopup';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

function ReportFilterCountCard({ title, setFilterData, onList, onGeneratePDF, filterType = "count", loading, setLoading }) {
    const [state, setState] = useState({
        inst: "",         // Kurum seçimi için
        unitId: [],       // Seçilen Unit ID'ler
        meetingNo: "",    // Toplantı Numarası
        type: -1,
        attendanceStatus: -1,
    });

    const [lastFilter, setLastFilter] = useState(null);
    const [hasData, setHasData] = useState(false);
    // Seçilen kuruma göre filtrelenmiş ünite listesini tutan state
    const [filteredUnits, setFilteredUnits] = useState([]);

    const filteredUnitList = useSelector(state => state.auth.allAuthorizedUnits);
    const allowedInstitutions = useSelector(state => state.auth.allAuthorizedInsts);

    // Eğer sadece bir adet kurum varsa, otomatik seç ve ilgili üniteleri filtrele
    useEffect(() => {
        if (allowedInstitutions.length === 1) {
            const onlyInst = allowedInstitutions[0];
            setState(prevState => ({ ...prevState, inst: onlyInst, unitId: [] }));
            const units = filteredUnitList.filter(unit => unit.inst === onlyInst);
            setFilteredUnits(units);
            // Eğer tek ünite varsa otomatik olarak state'e ekle
            if (units.length === 1) {
                setState(prevState => ({ ...prevState, unitId: units }));
            }
        }
    }, [allowedInstitutions, filteredUnitList]);

    // Kurum (inst) değiştiğinde çalışacak change fonksiyonu
    const handleInstChange = (e) => {
        const selectedInst = e.target.value;
        // Seçilen kuruma ait üniteleri filtrele
        const newFilteredUnits = filteredUnitList.filter(unit => unit.inst === selectedInst);
        setFilteredUnits(newFilteredUnits);
        // Eğer sadece tek ünite varsa, onu otomatik olarak state'e ekle; değilse boş bırak
        setState(prevState => ({
            ...prevState,
            inst: selectedInst,
            unitId: newFilteredUnits.length === 1 ? newFilteredUnits : []
        }));
    };

    return (
        <>
            <LoadingPopUp open={loading} />
            <JumboCardQuick title={title}>
                {!loading &&
                    <Grid container spacing={1}>
                        <Grid container item xs={8} spacing={2}>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="inst" size="small">Kurum</InputLabel>
                                    <Select
                                        labelId="inst"
                                        label="Kurum"
                                        size="small"
                                        value={state.inst}
                                        onChange={handleInstChange}
                                        required
                                        // Eğer yalnızca 1 kurum varsa, alanı kilitle
                                        disabled={allowedInstitutions.length === 1}
                                    >
                                        {allowedInstitutions.map((inst) => (
                                            <MenuItem key={inst} size="small" value={inst}>
                                                {inst}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={5}>
                                <Autocomplete
                                    multiple
                                    id="autocomplete"
                                    options={filteredUnits}
                                    size="small"
                                    getOptionLabel={(option) => option.name}
                                    value={state.unitId}
                                    onChange={(event, newValue) => {
                                        setState(prevState => ({ ...prevState, unitId: newValue }));
                                    }}
                                    disabled={filteredUnits.length === 1}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Kurul/Kol/Komisyon"
                                            placeholder="Kurul/Kol/Komisyon seçiniz"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    label="Toplantı Numarası"
                                    variant="outlined"
                                    size="small"
                                    value={state.meetingNo}
                                    onChange={(e) =>
                                        setState(prevState => ({ ...prevState, meetingNo: e.target.value }))
                                    }
                                />
                            </Grid>

                            {filterType !== "count" && (
                                <Grid container item xs={12} spacing={2}>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel id="type" size="small">Üye/Katılımcı</InputLabel>
                                            <Select
                                                labelId="type"
                                                label="Üye/Katılımcı"
                                                size="small"
                                                value={state.type || "1"}
                                                onChange={(e) =>
                                                    setState(prevState => ({ ...prevState, type: e.target.value }))
                                                }
                                            >
                                                <MenuItem value="-1" selected>Tümü</MenuItem>
                                                <MenuItem value="1">Üye</MenuItem>
                                                <MenuItem value="2">Katılımcı</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel id="attendanceStatus" size="small">Katılım Durumu</InputLabel>
                                            <Select
                                                labelId="attendanceStatus"
                                                label="Katılım Durumu"
                                                size="small"
                                                value={state.attendanceStatus || "1"}
                                                onChange={(e) =>
                                                    setState(prevState => ({ ...prevState, attendanceStatus: e.target.value }))
                                                }
                                            >
                                                <MenuItem value="-1" selected>Tümü</MenuItem>
                                                <MenuItem value="1">Katıldı</MenuItem>
                                                <MenuItem value="0">Katılmadı</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>

                        <Grid item xs={4}>
                            <Grid item xs={12}>
                                <ButtonGroup>
                                    <Button
                                        variant="outlined"
                                        size="large"
                                        color="success"
                                        startIcon={<List />}
                                        onClick={() => {
                                            const filters = {
                                                inst: state.inst,
                                                unitId: state.unitId,
                                                meetingNo: state.meetingNo,
                                                ...(filterType !== "count" && {
                                                    type: state.type,
                                                    attendanceStatus: state.attendanceStatus,
                                                }),
                                            };
                                            onList(filters, setState, setLastFilter, setHasData, setLoading);
                                        }}
                                        disabled={!state.inst && state.unitId.length === 0 && !state.meetingNo}
                                    >
                                        Listele
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="large"
                                        color="success"
                                        startIcon={<PictureAsPdf />}
                                        onClick={() => onGeneratePDF(lastFilter, setLoading)}
                                        disabled={!hasData}
                                    >
                                        PDF
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="large"
                                        color="success"
                                        startIcon={<DeleteIcon />}
                                        onClick={() => {
                                            setState({
                                                inst: "",
                                                unitId: [],
                                                meetingNo: "",
                                                type: -1,
                                                attendanceStatus: -1,
                                            });
                                            setFilterData(null);
                                            setHasData(false);
                                            // Temizlerken filtrelenmiş unit listesini de sıfırla
                                            setFilteredUnits([]);
                                        }}

                                    >
                                        TEMİZLE
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </JumboCardQuick>
        </>
    );
}

export default ReportFilterCountCard;
